import React, { useEffect, useMemo, useReducer, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { enumUtil } from "../../utils/Enum";
import { ServerRequestProtected } from "../../utils/ServerDataRequest";
import { TabActionPatient } from "../../actions/PatientActions";
import 'react-data-grid/lib/styles.css';
import Loader from "../shared/Loader/Loader";
import { useSelector } from "react-redux";
import { Alphbets } from "../../utils/Constants";
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css'; // theme css file
import Table from "../Setup/Shared/Table";
import GridColumnHeader from "../Setup/Shared/GridColumnHeader"
import { PatientRecordAction } from "../../actions/PatientActions";
import SearchHeader from "../Setup/Shared/SearchHeader";
import OpenQuickPopup from "../shared/OpenQuickPopup/OpenQuickPopup";
import SuperSearchList from "../shared/SuperSearch/SuperSearchList";
import { Modal } from "react-bootstrap";
import ModalHeader from "../Setup/Shared/ModalHeader";
import DataGrid from 'react-data-grid';
import CalendaRangeInput from "../General/CalendarRangeInput";
import handleCopyText from "../shared/CopyData";
import AmountFormatter from "../../utils/AmountFormatter";
import ContentReceiver from "../MenuLayout/ContentReceiverNewBrowserTab/ContentReceiver";
import { FindFirstChild } from "../../utils/FindMenuOption";
import SuperSearchMultipleClient from "../shared/SuperSearch/MultipleSelection/SuperSearchMultipleClient";
import { GeneralDropDowns } from "../../actions/GeneralPatientActions";
import HandleSelectColumnName from "../../utils/HandleSelectColumnName";
import { MainBarActiveTabsAction } from "../../actions/MainBarActiveTabsAction";
import CustomUseRef from "../shared/DropDown/CustomUseRef";
import InstantEligibility from "./PatientInstantEligibility/InstantEligibility";
import EligibilityBulk from "./Eligibility Bulk/EligibilityBulk";
import { SelectColumn } from "react-data-grid"
import NotificationHandler from "../../utils/NotificationHandler";
import isNull from "../../utils/NullChecking";


const PatientSearch = (props) => {
    const { Settings } = { ...props }
    let isEditAllowed = FindFirstChild('Patient', 'Patients')?.ISView
    let isBulkViewAllowed = FindFirstChild('Patient', 'Bulk Eligibility')?.IsAdd
    let isInstantViewAllowed = FindFirstChild('Patient', 'Instant Eligibility')?.IsAdd
    let SidebarActive = useSelector(state => state.SidebarActiveTab);

    let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    const API_URL_PATIENT = enumUtil.controller.PATIENT
    const API_URL_Agency = enumUtil.controller.AgencyPatient
    let dispatch = useDispatch();
    const [filterShow, setFilterShow] = useState(false);
    let DropdownData = useSelector(state => state.GeneralDropDownsReducer)
    const isHomeCareCheck = DropdownData.IsHomeCare
    const [patientData, setPatientData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [popup, setPopup] = useState(<></>);
    const [IsFilterApplied, setIsFilterApplied] = useState(false)
    const [copiedText, setCopiedText] = useState({});
    let searchFieldData = useSelector(state => state.MainBarActiveTabsReducer?.['Patient']?.SearchField);
    console.log("searchFieldData", searchFieldData)

    ////////====GridColumnHeader=========//////////
    const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
        return { ...prev, ...next }
    }, { defaultData: '', activeSortIcon: '' })
    ///Search///
    const Search_Data = {
        "SearchLetter": "",
        "SearchCeriteria": "",
        "InsuranceID": "",
        "LocationID": "-1",
        "ProviderID": "-1",
        "CoordinatorID": "",
        "Status": "",
        "Date": null,
        "EligStatus": ''
    }
    const searchButton = {
        AddNew: true,
        Excel: true,
        PDF: true,
        Delete: false,
        Filter: true,
        View: false  // set true if want to display cards as well
    }
    const API_URL_GENERAL = enumUtil.controller.General
    let isHomecareOrADC = useSelector(state => ["Adult Day Care", "Homecare Agency"].includes(state.GeneralDropDownsReducer.PracticeType))
    const [searchParam, setSearchParam] = useState(Search_Data)
    const [openTab, setOpenTab] = useState('')
    const [searchLoad, setSearchLoad] = useState(false)
    const [selectedInsurance, setSelectedInsurance] = useState('')
    const [selectCoordinator, setselectCoordinator] = useState('')
    const [selectprovider, setselectprovider] = useState('')
    const [selectLocation, setselectLocation] = useState('')
    const [statusDefault, setStatusDefault] = useState([])
    const [subMenuActive, setSubMenuActive] = useState(false);
    const [clear, setClear] = useState(false);
    const [reloadSuperSearch, setReloadSuperSearch] = useState(false)
    const [selectedRows, setSelectedRows] = useState(new Set())
    const [selectedClaimId, setSelectedClaimID] = useState([])


    //For Pagination
    const [PerPage, setPerPage] = useState(Settings?.PaginationDefaultRows);
    const [PageNo, setPageNo] = useState(1);
    const [TotalPages, setTotalPages] = useState();
    const handlePageClick = (page) => { setPageNo(page); }
    const PreviousPage = () => { if (PageNo > 1) setPageNo(PageNo - 1); }
    const NextPage = () => { if (PageNo < TotalPages) setPageNo(PageNo + 1); }
    const handleFingByCreteria = (e) => {
        setPerPage(e.target.value)
        setPageNo(1)
    }
    const handleSelectData = (data) => {
        setPerPage(data.value)
        setPageNo(1)
    }
    ///////////
    const AddNewPatient = () => {
        let dataObj = {
            key: 2,
            name: "Patient",
            active: true,
            data: {
                name: "New Patient",
                id: -1,
                time: new Date()
            },
        };
        dispatch(GeneralDropDowns({
            ...GenDD, DisCardActiveIds: {
                ...GenDD?.DisCardActiveIds,
                Patient: [...GenDD?.DisCardActiveIds.Patient, {
                    isDemographicsOpened: false,
                    isDemographicsUpdated: false,
                    isInsuranceOpened: false,
                    isInsuranceUpdated: false,
                    PatientID: -1,
                }]
            }
        }))
        props.TabActionPatient(dataObj);
    }
    const LoadData = (searchParam) => {
        setIsLoading(true);
        setPatientData([])
        let apilink = isHomeCareCheck === "true" ? API_URL_Agency : API_URL_PATIENT
        ServerRequestProtected(apilink + "/FindPatientByMultipleCriteria", 'post', {
            "TableName": isHomeCareCheck === "true" ? enumUtil.enumAPITableName.AgencyPatient : enumUtil.enumAPITableName.Patient,
            "SearchCriteria": searchParam,
            "PerPage": PerPage,
            "PageNo": PageNo,
        })
            .then((response) => {
                setIsLoading(false);
                setPatientData(response.Rows)
                setTotalPages(response.count.NumOfPages);

                handleGridHeader({ defaultData: response.Rows })
                let PatientData = [];
                PatientData = response.Rows.map((item, index) => {
                    let newlist = { ID: item.id, name: item.FirstName, FullName: item.FirstName + ', ' + item.LastName + ', ' + item.AccountNumber }
                    return newlist;

                })
                dispatch(PatientRecordAction(PatientData))
                setSelectedClaimID([]);
            }).catch((error) => {
                // console.log("ERROR", error)
                // NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
                setPatientData([])
                setIsLoading(false);
                setSelectedClaimID([]);
                setSelectedRows((new Set()));
            })
    }
    const SearchOnEnter = (e) => {
        if (e.key === "Enter") {
            setSearchParam({ ...searchParam, SearchCeriteria: e.target.value })
            SearchByParam(searchParam)
        }
    }
    const SearchByParam = () => {
        if(!isEditAllowed) return
        if (!isNull(searchParam)) {
            setPageNo('1')
            LoadData(searchParam)
        } else {
            LoadData()
        }
    }
    const handleApply = () => {
        setIsFilterApplied(true)
        if (!isNull(searchParam)) {
            setPageNo('1')
            LoadData(searchParam)
        } else {
            LoadData()
        }
    }
    useEffect(() => {
        if (isEditAllowed) {
            if (searchFieldData === undefined) {
                setIsLoading(true);
                setPatientData([])
                LoadData(searchParam)
            }
        }
    }, [PerPage, PageNo, searchLoad]) //seacrhParam
    useEffect(() => { props.setRecordsNum(patientData.length) }, [patientData])

    useEffect(() => {
        ////To set Status field on Navigation from Billing Items////
        if (searchFieldData) {
            // Set Default Search Data
            Object.keys(searchParam).forEach(key => searchParam[key] = Search_Data[key]);
            searchParam.SearchCeriteria = searchFieldData.SearchCeriteria
            setSearchParam(() => (searchParam))
            dispatch(MainBarActiveTabsAction({ 'Patient': { ActiveTabKey: 2, SearchField: undefined } }));
        }
        if (searchFieldData !== undefined) {
            LoadData(searchParam);
        }
    }, [searchFieldData]) //seacrhParam
    let GenDD = useSelector(state => state.GeneralDropDownsReducer)

    const OpenPatient = (data) => {
        let obj = {
            key: 2,
            name: "Patient",
            active: true,
            data: {
                id: data.PatientID,
                name: data.FirstName,
                FullName: data.LastName + " " + data.FirstName,
                time: new Date(),
            },
        };
        props.TabActionPatient(obj);

        setTimeout(() => {
            AddEmptyValuesForPatDiscard(data);
        }, 0);
    }
    const AddEmptyValuesForPatDiscard = (data) => {
        dispatch(GeneralDropDowns({
            ...GenDD, DisCardActiveIds: {
                ...GenDD?.DisCardActiveIds,
                Patient: [...GenDD?.DisCardActiveIds.Patient, {
                    isDemographicsOpened: false,
                    isDemographicsUpdated: false,
                    isInsuranceOpened: false,
                    isInsuranceUpdated: false,
                    PatientID: data.PatientID,
                }]
            }
        }))
    }

    const OpenPatientDetails = (data, type) => {
        let obj = {
            key: 2,
            name: "Patient",
            active: true,
            data: {
                id: data.PatientID,
                name: data.FirstName,
                time: new Date(),
                type: type,
            },
        };
        props.TabActionPatient(obj);
    }
    /////// viewAllClaims ///////
    const handleViewAllClaim = (PatID, PatName) => {
        let dataObj = {
            key: 2,
            name: "Claims",
            active: true,
            data: {
                name: "All Claims",
                id: 0,
                time: new Date(),
                visitType: {
                    type: 'ClaimSearch',
                    PatientID: PatID,
                    PatientName: PatName,
                },
            },
        };
        setOpenTab(dataObj)
    }
    const OpenQuickPopupMemoized = ({ row, setPopup, name }) => {
        const memoizedPopup = useMemo(() => {
            if (name === 'Insurance') {
                return (
                    <OpenQuickPopup ID={row.PrimaryInsuranceID} name={row.PrimaryInsurance} setPopup={setPopup} popupName={name} />);
            }
        }, [row, name]);

        return memoizedPopup;
    };
    const handleCopy = (row, type) => {
        let name = `${row}-${type}`;
        handleCopyText(type);
        setCopiedText({ ...copiedText, [name]: true });
        setTimeout(() => {
            setCopiedText({ ...copiedText, [name]: false });
        }, 300)
    }
    const [checkBoxShow, setCheckBoxShow] = useState(false);

    const onRowSelection = (listOfIdsSet) => {
        let newList = [];
        const listOfIds = Array.from(listOfIdsSet);
        const validIds = listOfIds.filter((id) => {
            const row = patientData.find((el) => el.id === id);
            return row && !isNull(row.PrimaryInsurance);
        });
        validIds.forEach((id) => {
            const el = patientData.find((row) => row.id === id);
            if (el) {
                newList.push(el);
            }
        });
        setSelectedRows(new Set(validIds));
        const commaSeparatedIds = validIds.join(", ");
        setSelectedClaimID(commaSeparatedIds);
    };
    const columns =
        [
            ...(checkBoxShow ? [{
                ...SelectColumn,
                cellClass: (row) => isNull(row.PrimaryInsurance) || row.PrimaryInsurance === 'SELF PAY' ? 'disabled-row' : '',
            }] : []),
            {
                width: 90,
                key: 'empty',
                name: '',
                renderCell({ row }) {
                    return (
                        <div className="d-flex align-items-center pat_claim">
                            <span className='app_tooltip right h-100 lh-1' onClick={() => OpenPatientDetails(row, "Demographics")}>
                                <i className="icon-Demographics-icon "></i>
                                <p class="tool_tip xsm_text text-light">Demographics</p>
                            </span>
                            <span className='app_tooltip right h-100 lh-1' onClick={() => OpenPatientDetails(row, "Insurances")}>
                                <i className="icon-umbrella-solid"></i>
                                <p class="tool_tip xsm_text text-light">Insurances</p>
                            </span>
                            <span className='app_tooltip right h-100 lh-1' onClick={() => handleViewAllClaim(row.PatientID + "", row.FirstName + ' ' + row.LastName,)}>
                                <span class="icon-pateintclaim fs-15"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span></span>
                                <p class="tool_tip xsm_text text-light">Claims</p>
                            </span>
                            {isHomecareOrADC ? <></> :
                                <div className="app_tooltip right" onClick={() => OpenPatientDetails(row, "Encounter")}>
                                    <i className="icon-document-add-svgrepo-com ar-dark-icon fs-15"></i>
                                    <p className="tool_tip xsm_text text-light">View Encounter</p>
                                </div>}
                        </div>
                    );
                },
            },
            {
                key: 'AccountNumber',
                width: 120,
                name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                    iconName={'icon-location'} headerName={'Account#'} sortIcon={true} type={'number'} colKey={'AccountNumber'} data={patientData} setData={setPatientData} />),
                resizable: true,
                renderCell({ row }) {
                    return (
                        <>
                            <button className="btn btn-link w-100">

                                <div className="d-flex copy_icon_hover justify-content-between w-100 align-items-center copy_icon gap-1">
                                    <div className="validation_message" onClick={() => OpenPatient(row)}>{row.AccountNumber} </div>
                                    <div className="icon_copy">
                                        {/* <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopyText(row.AccountNumber)}></i>  */}
                                        {/* <p class="tool_tip xsm_text text-light">Copy</p> */}
                                    </div>
                                </div>
                            </button>
                            <div className="circles">
                                {row.PatientValidation === 'True' ? <span className="green_circle"></span> : <span className="red_circle"></span>}
                                <div className='missing_detail'>
                                    <div className='demo missing_data'>
                                        <span className='d-flex align-items-center justify-content-between'>
                                            <span class="icon-Group-4785"><span class="path1 fs-18"></span><span class="path2 "></span><span class="path3 "></span></span>
                                            Demographic have some data missing <span className='detail border-0'>
                                                <i className='cursor-pointer icon-Icon-metro-cross'></i>
                                            </span>
                                        </span>
                                        <div className='message_list'>
                                            <p className={`${row.PatientErrorMessages ? "text " : "mb-0"}`}>{row.PatientErrorMessages}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <button
                        className="table-btn" onClick={() => OpenPatient(row)}>
                        {row.FirstName}{' '}{row.LastName}
                    </button> */}
                        </>
                    );
                },
            },
            // {
            //     key: 'Profile',
            //     name: (<GridColumnHeader iconName={'icon-umbrella-solid'} headerName={'Profile'} sortIcon={false}/>),
            //     resizable: true,
            //     renderCell({ row }
            //     ) {
            //         return (
            //             <>
            //                 {/* <button
            //                 className="table-btn" onClick={() => OpenPatient(row)}>
            //                 {row.AccountNumber}
            //             </button> */}
            //                 {/* {row.FirstName === 'Taimoor' ? <i className="icon-male-icon"></i> : <i className="icon-female-icon"></i>}
            //             <button
            //                 className="table-btn" onClick={() => OpenPatient(row)}>
            //                 {row.FirstName}{' '}{row.LastName}
            //             </button> */}
            //                 {/* <div className="circles">
            //                     {row.Completed === 'true' ?
            //                         <span className="green_circle"></span>
            //                         :
            //                         <span className="red_circle">
            //                         </span>   
            //                     }
            //                          <div className='missing_detail'>
            //                         <div className='demo missing_data'>
            //                             <span className='d-flex align-items-center'>
            //                                 <img src={demoicon}></img>
            //                                 Demographic have some data missing <span className='detail border-0'>
            //                                     <i className='cursor-pointer icon-Icon-metro-cross'></i>
            //                                     </span>
            //                             </span>
            //                             <div className='message_list'>
            //                                 <p className='text'>Patient Address is missing.</p>
            //                                 <p className='text'>Patient DOB is missing.</p>
            //                                 <p className='text'>Patient Address is missing.</p>
            //                             </div>
            //                         </div>
            //                         </div>
            //                 </div> */}
            //             </>
            //         );
            //     }
            // },
            {
                key: 'LastName',
                name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                    iconName={'icon-Icon-material-date-range'} headerName={'Last Name'} sortIcon={true} type={'string'} colKey={'LastName'} data={patientData} setData={setPatientData} />),
                resizable: true,
                renderCell: ({ row }) => {
                    return (
                        <>
                            <div className="align-items-center copy_icon pri_ins copy_icon_hover d-flex gap-1 justify-content-between w-100">
                                <div className="copy_icon validation_message" title={row.LastName}>
                                    {row.LastName}
                                </div>
                                {row.LastName && (
                                    <div className="icon_copy">
                                        <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.PatientID, row.LastName)} ></i>
                                        <p className="tool_tip xsm_text text-light">Copy</p>
                                    </div>
                                )}
                                {copiedText[`${row.PatientID}-${row.LastName}`] ? (
                                    <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p>
                                ) : (
                                    <></>
                                )}
                            </div>
                        </>
                    );
                },
            },
            {
                key: 'FirstName',
                name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                    iconName={'icon-Icon-material-date-range'} headerName={'First Name'} sortIcon={true} type={'string'} colKey={'FirstName'} data={patientData} setData={setPatientData} />),
                resizable: true,
                renderCell: ({ row }) => {
                    return (
                        <>
                            <div className="align-items-center copy_icon pri_ins copy_icon_hover d-flex gap-1 justify-content-between w-100">
                                <div className="copy_icon validation_message" title={row.FirstName}>
                                    {row.FirstName}
                                </div>
                                {row.FirstName && (
                                    <div className="icon_copy">
                                        <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.PatientID, row.FirstName)} ></i>
                                        <p className="tool_tip xsm_text text-light">Copy</p>
                                    </div>
                                )}
                                {copiedText[`${row.PatientID}-${row.FirstName}`] ? (
                                    <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p>
                                ) : (
                                    <></>
                                )}
                            </div>
                        </>
                    );
                },
            },
            {
                key: 'DOB',
                name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                    iconName={'icon-Icon-material-date-range'} headerName={'DOB'} sortIcon={true} type={'date'} colKey={'DOB'} data={patientData} setData={setPatientData} />),
                resizable: true,
            },
            {
                key: 'SSN',
                name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                    iconName={'icon-Icon-material-date-range'} headerName={'SSN'} sortIcon={true} type={'string'} colKey={'SSN'} data={patientData} setData={setPatientData} />),
                resizable: true,
                renderCell: ({ row }) => {
                    return (
                        <>
                            <div className="align-items-center copy_icon pri_ins copy_icon_hover d-flex gap-1 justify-content-between w-100">
                                <div className="copy_icon validation_message" title={row.SSN}>
                                    {row.SSN}
                                </div>
                                {row.SSN && (
                                    <div className="icon_copy">
                                        <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.PatientID, row.SSN)} ></i>
                                        <p className="tool_tip xsm_text text-light">Copy</p>
                                    </div>
                                )}
                                {copiedText[`${row.PatientID}-${row.SSN}`] ? (
                                    <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p>
                                ) : (
                                    <></>
                                )}
                            </div>
                        </>
                    );
                },
            },

            {
                key: 'PrimaryInsurance',
                name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                    iconName={'icon-Icon-map-insurance-agency'} headerName={'Pri Insurance'} sortIcon={true} type={'string'} colKey={'PrimaryInsurance'} data={patientData} setData={setPatientData} />),
                resizable: true,
                renderCell: ({ row }) => {
                    return (
                        <>
                            <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                                <div className="copy_icon validation_message w-100">
                                    {row.PrimaryInsurance !== 'SELF PAY' ? <OpenQuickPopupMemoized row={row} setPopup={setPopup} name={'Insurance'} /> : <span className="text fst-italic font-m ">{row.PrimaryInsurance}</span>}
                                    {/* <OpenQuickPopup ID={row.PrimaryInsuranceID} name={row.PrimaryInsurance} setPopup={setPopup} popupName={'Insurance'} /> */}
                                </div>
                            </div>
                            <div className="circles">
                                {row.PatientInsuranceValidation === 'True' ? <span className="green_circle"></span> : <span className="red_circle"></span>}
                                <div className='missing_detail'>
                                    <div className='demo missing_data'>
                                        <span className='d-flex align-items-center'>
                                            <span class="icon-Group-4785"><span class="path1 fs-18"></span><span class="path2 "></span><span class="path3 "></span></span>
                                            Demographic have some data missing <span className='detail border-0'>
                                                <i className='cursor-pointer icon-Icon-metro-cross'></i>
                                            </span>
                                        </span>
                                        <div className='message_list'>
                                            <p className='text'>{row.PatientInsuranceErrorMessages}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    );
                },
            },
            {
                key: 'PrimarySubscriberID',
                name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                    iconName={'icon-address'} headerName={'Pri Insured ID'} sortIcon={true} type={'number'} colKey={'PrimarySubscriberID'} data={patientData} setData={setPatientData} />),
                resizable: true,
                renderCell: ({ row }) => {
                    return (
                        <>
                            <div className="align-items-center copy_icon pri_ins copy_icon_hover d-flex gap-1 justify-content-between w-100">
                                <div className="copy_icon validation_message" title={row.PrimarySubscriberID}>
                                    {row.PrimarySubscriberID}
                                </div>
                                {row.PrimarySubscriberID && (
                                    <div className="icon_copy">
                                        <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.PatientID, row.PrimarySubscriberID)} ></i>
                                        <p className="tool_tip xsm_text text-light">Copy</p>
                                    </div>
                                )}
                                {copiedText[`${row.PatientID}-${row.PrimarySubscriberID}`] ? (
                                    <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p>
                                ) : (
                                    <></>
                                )}
                            </div>
                        </>
                    );
                },
            },
            ...(isHomeCareCheck === "true" ? [{
                key: 'MedicaidNo',
                name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                    iconName={'icon-Icon-material-date-range'} headerName={'Medicaid #'} sortIcon={true} type={'string'} colKey={'MedicaidNo'} data={patientData} setData={setPatientData} />),
                resizable: true,
                renderCell: ({ row }) => {
                    return (
                        <>
                            <div className="align-items-center copy_icon pri_ins copy_icon_hover d-flex gap-1 justify-content-between w-100">
                                <div className="copy_icon validation_message" title={row.MedicaidNo}>
                                    {row.MedicaidNo}
                                </div>
                            </div>
                        </>
                    );
                },
            }] : []),
            {
                key: 'EligibilityDate',
                name: (<GridColumnHeader iconName={'icon-Icon-awesome-address-card'} headerName={'Eligibility'} sortIcon={false} />),
                resizable: true,
                resizable: true,
                width: 164,
                renderCell: ({ row }) => {
                    return (
                        <>
                            <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                                <div className="copy_icon validation_message">{row.EligibilityDate ? row.EligibilityDate : 'N/A'}</div>
                            </div>
                            <div className="circles">
                                {
                                    row.EligibilityValidation === 'Processed' ? (
                                        <span className="text-primary" >{row.EligibilityValidation}</span>
                                    ) : row.EligibilityValidation === 'Active' ? (
                                        <span className="text-success">{row.EligibilityValidation}</span>
                                    ) : row.EligibilityValidation === 'Inactive' ? (
                                        <span className="text-muted">{row.EligibilityValidation}</span>
                                    ) : row.EligibilityValidation === 'Not Processed' ? (
                                        <span className="text-warning">{row.EligibilityValidation}</span>
                                    ) : (
                                        <span></span>
                                    )
                                }
                                <div className='missing_detail'>
                                    <div className='demo missing_data'>
                                        <span className='d-flex align-items-center'>
                                            <span class="icon-Group-4785"><span class="path1 fs-18"></span><span class="path2 "></span><span class="path3 "></span></span>
                                            Demographic have some data missing <span className='detail border-0'>
                                                <i className='cursor-pointer icon-Icon-metro-cross'></i>
                                            </span>
                                        </span>
                                        <div className='message_list'>
                                            <p className='text'>Patient Address is missing.</p>
                                            <p className='text'>Patient DOB is missing.</p>
                                            <p className='text'>Patient Address is missing.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )
                }
            },
            ...(isHomeCareCheck === "true" ? [{
                key: 'Status',
                name: (<GridColumnHeader iconName={'icon-Icon-awesome-address-card'} headerName={'Status'} sortIcon={false} />),
                resizable: true,
                renderCell: ({ row }) => {
                    return (
                        <p className={`pill w-max-content ${row.Status === 'Active' ? 'ar-user_active' : row.Status === 'Hold' ? 'Hold' : row.Status === 'Discharged' ? 'Discharge' : row.Status === 'Hospitalization' ? 'Hospitalization' : row.Status === 'Vacation' ? 'Vacation' : ''}`}>{row.Status}</p>
                    );
                },

            }] : [
                {
                    key: 'Balance',
                    name: (<GridColumnHeader iconName={'icon-Icon-awesome-address-card'} headerName={'Pat. Balance'} sortIcon={false} />),
                    resizable: true,
                    renderCell: ({ row }) => {
                        return (<AmountFormatter amount={row.Balance} />);
                    },
                }
            ]),

            {
                key: 'Status',
                name: (<GridColumnHeader iconName={'icon-Icon-awesome-address-card'} headerName={'Status'} sortIcon={false} />),
                resizable: true,
                width: 80,
                renderCell: ({ row }) => {
                    return (
                        <p className={`pill ${row?.Status === 'Active' ? 'Paid' : 'Denied'}`}>{row.Status}</p>
                    )
                }
            },
        ];
    const AllColumnsName = HandleSelectColumnName(columns);

    ////Search Letters////
    const handleSearchByAlphabet = (e) => {
        setSearchParam({
            SearchLetter: e, SearchCeriteria: "", InsuranceID: null, LocationID: null,
            ProviderID: null, Date: null
        })
        setSearchLoad(searchLoad => !searchLoad)
    }
    const handleNextAlphabet = () => {
        if (searchParam.SearchLetter === 'Z') {
            setSearchParam({ ...searchParam, SearchLetter: 'A' })
        } else {
            setSearchParam({ ...searchParam, SearchLetter: String.fromCharCode(searchParam.SearchLetter.charCodeAt(0) + 1) });
        }
        setSearchLoad(searchLoad => !searchLoad)
    }
    const handlePreviousAlphabet = () => {
        if (searchParam.SearchLetter === 'A') {
            setSearchParam({ ...searchParam, SearchLetter: 'Z' });
        } else {
            setSearchParam({ ...searchParam, SearchLetter: String.fromCharCode(searchParam.SearchLetter.charCodeAt(0) - 1) });
        }
        setSearchLoad(searchLoad => !searchLoad)
    }
    const clearFilter = () => {
        setIsFilterApplied(false)
        setReloadSuperSearch(!reloadSuperSearch)
        setSearchParam({
            SearchLetter: "", SearchCeriteria: "", InsuranceID: "",
            LocationID: "-1", ProviderID: "-1", Date: null, CoordinatorID: ''
        })
        setSelectedInsurance('')
        setselectCoordinator('')
        setselectprovider('')
        setselectLocation('')
        setFilterShow(false)
        setClear(true)
        setSelectedClaimID([]);
        setSelectedRows((new Set()));
    }
    const rowClass = () => { return "row-bg" }
    const [is, setIs] = useState(false);

    const columnsAll = [
        { key: 'Account', name: 'Account #' },
        { key: 'Name', name: 'Name' },
        { key: 'DOB', name: 'Date of Birth' },
        { key: 'Insured', name: 'Insured' },
        { key: 'BalanceDuePat', name: 'Balance due Pat.' },
        { key: 'AccountPhone', name: 'Account Phone' },
    ]

    const rowsAll = [
        { "Account": "3129831298", "Name": "Alex", "DOB": "04/19/2017", "Insured": "", "BalanceDuePat": "1234", "AccountPhone": "1234567890" },
    ]

    const patientHeader = () => {
        return <p style={{ color: '#434343', fontFamily: 'Poppins', fontWeight: '600', margin: '0', fontSize: '15px' }}>Patient Search</p>;
    };
    const StatusOption1 = [
        { value: "Active", display: "Active" },
        { value: "Hold", display: "Hold" },
        { value: "Discharged", display: "Discharged" },
    ]
    const StatusOptionGrp = [
        { value: "1", display: "Active" },
        { value: "0", display: "Inactive" },
    ]
    const StatusOption = [
        { color: "Paid-bg", value: "Active", display: "Active" },
        { color: "InActive-bg", value: "InActive", display: "In Active" },
        { color: "RejectedPayer-bg", value: "Rejected", display: "Rejected" },
        { color: "PartialDenied-bg", value: "Failed", display: "Failed" }
    ];
    const closeDropdown = () => {
        setFilterShow(false)

    };
    const handleFilterOpen = (e) => {
        setFilterShow(!filterShow)
        e.stopPropagation();

    }
    const handleSelectedData = (selectedData, name, type) => {
        console.log(selectedData);
        if (type === 'client' && !isNull(selectedData)) {
            if (name === "InsuranceID" && !isNull(selectedData)) {
                setSearchParam({ ...searchParam, SearchLetter: null, InsuranceID: selectedData.value + "" });
                setSelectedInsurance(selectedData.display);
            }
            if (name === "CoordinatorID" && !isNull(selectedData)) {
                setSearchParam({ ...searchParam, SearchLetter: null, CoordinatorID: selectedData.value + "" });
                setselectCoordinator(selectedData.display);
            }
            if (name === "ProviderID" && !isNull(selectedData)) {
                // setProviderID(selectedData.value + "")
                setSearchParam({ ...searchParam, SearchLetter: null, ProviderID: selectedData.value + "" });
                setselectprovider(selectedData.display)
            }
            if (name === "LocationID" && !isNull(selectedData)) {
                // setProviderID(selectedData.value + "")
                setSearchParam({ ...searchParam, SearchLetter: null, LocationID: selectedData.value + "" });
                setselectLocation(selectedData.display)
            }
            if (name === "RefProviderID" && !isNull(selectedData)) {
                // setRefProviderID(selectedData.value + "")
            }
        } else if (type === 'server' && !isNull(selectedData)) {

        } else {

        }

        return selectedData
    }
    const handleMUltiSelectedData = (selectedDataArray, type, name) => {
        console.log("selectedDataArray", selectedDataArray)
        let modal = { ...searchParam };
        if (type === 'server' && selectedDataArray.length > 0) {
            const displayValues = selectedDataArray.map(data => data.display);
            const valueValues = selectedDataArray.map(data => data.value);
            modal[name] = displayValues.join(', ');
            // PatientSaveUpdateModal[name] = valueValues.join(', ');
        } else if (type === 'client' && selectedDataArray.length > 0) {
            const displayValues = selectedDataArray.map(data => data.display);
            const valueValues = selectedDataArray.map(data => data.value);
            let joinvlues = valueValues.join(', ');
            modal[name] = valueValues.join(', ');
            if (name === "InsuranceID" && !isNull(selectedDataArray)) {
                setSelectedInsurance(joinvlues);
            }
        }
        else {
            console.log("selectedDataArray");
            modal[name] = '';
            // PatientSaveUpdateModal[name] = '';
        }
        setSearchParam(modal);
        // setPatientSaveUpdateModal(PatientSaveUpdateModal);
        return selectedDataArray;
    }
    const handleChange = (e) => {
        let { name, value } = e.target
        // setSearchParam({ ...searchParam, SearchLetter: null, name: value || null })
        if (name === 'InsuranceID') {
            setSelectedInsurance(value)
        } else if (name === 'CoordinatorID') {
            setselectCoordinator(value)
        }
        else if (name === 'ProviderID') {
            setselectprovider(value)
        }
        else if (name === 'LocationID') {
            setselectLocation(value)
        }
    }
    const handleSubActiveMenu = (e) => {
        setSubMenuActive(!subMenuActive)
        e.stopPropagation();
    }

    const [isOpenInstantEligibility, setIsOpenInstantEligibility] = useState(false);
    const [isOpenBulkEligibility, setIsOpenBulkEligibility] = useState(false);

    const handleOpenInstantElibility = () => {
        if (isInstantViewAllowed) {
            setIsOpenInstantEligibility(true)
        }
    }
    const handleCloseInstantElibility = () => {
        setIsOpenInstantEligibility(false)
    }
    let InstantEligibilityPopup = ""

    if (isOpenInstantEligibility) {
        InstantEligibilityPopup = <InstantEligibility isOpenInstantEligibility={isOpenInstantEligibility} CloseInstantElibility={handleCloseInstantElibility} />
    }
    const hanldeOpenBulkEligibity = () => {
        if (isBulkViewAllowed) {
            setCheckBoxShow(true);
            if (selectedClaimId?.length > 0) {
                setIsOpenBulkEligibility(true)
            }
            if (selectedClaimId?.length === 0 && checkBoxShow) {
                NotificationHandler('Please Select Row', enumUtil.enumtoaster.warning)
            }
        }
    }
    const handleCloseBulkEligibity = () => {
        setCheckBoxShow(false);
        setSelectedRows((new Set()));
        setSelectedClaimID([]);
        setIsOpenBulkEligibility(false)
    }
    let BulkEligibilityPopup = ""
    if (isOpenBulkEligibility) {
        BulkEligibilityPopup = <EligibilityBulk isOpenBulkEligibility={isOpenBulkEligibility} CloseBulkEligibity={handleCloseBulkEligibity} SelectID={selectedClaimId} type="Patient" />
    }
    return (
        <>
            {popup}
            {InstantEligibilityPopup}
            {BulkEligibilityPopup}
            <div className='p-2 pt-1 pb-0'>
                {openTab ? <ContentReceiver data={openTab} setOpenTab={setOpenTab} /> : null}
                <div className='alphabetic-filter m-auto'>
                    <button className='refresh active'>
                        <i className="icon-Icon-awesome-sync-alt" onClick={() => handleSearchByAlphabet(null)}></i>
                    </button>
                    <button>
                        <i className='icon-angle-left' onClick={handlePreviousAlphabet}></i>
                    </button>
                    <div className='alphabetics'>
                        {/* <span value={searchParam} >{searchParam}</span> */}
                        {Alphbets.map((type) => {
                            return (
                                <span className={type.value === searchParam.SearchLetter ? 'active' : ''} onClick={() => handleSearchByAlphabet(type.value)} key={type.value}>{type.value}</span>
                            )
                        })}
                    </div>
                    <button>
                        <i className='icon-right-direction' onClick={handleNextAlphabet}></i>
                    </button>
                </div>
            </div>
            <div className="container-fluid py-2">
                <div className="d-flex justify-content-between gap-1 align-items-end">
                    <div className="row row-half row-gap-15 flex-grow-1">
                        <div className="col-lg-3">
                            <div className="input">
                                <label className="hs-patient-label">Name</label>
                                <input type="text" className="form-control rounded"
                                    placeholder="Search by name, ssn, Insured id or Medicaid…"
                                    value={searchParam.SearchCeriteria}
                                    onChange={e => setSearchParam({ ...searchParam, SearchLetter: null, SearchCeriteria: e.target.value })}
                                    onKeyDown={SearchOnEnter}
                                />
                            </div>
                        </div>
                        <div className="col-md-3 multipleSearch-rounded">
                            <div className='input simple_select position-relative'>
                                <label className="hs-patient-label">Insurance</label>

                                <SuperSearchMultipleClient
                                    key={reloadSuperSearch}
                                    id="InsuranceID"
                                    name="InsuranceID"
                                    selectedOptionsDisplay='Insurance'
                                    initialSelectedValues={[]}
                                    options={DropdownData.Insurance?.filter(item => !['-1', -1].includes(item.value))}
                                    searchParam={searchParam}
                                    setSearchParam={setSearchParam}
                                    onSelect={handleMUltiSelectedData}
                                    sup_btn="sup_btn-Inp"
                                    sup_inp="superSearchVisitInp"
                                />
                            </div>
                        </div>
                        {/* {isHomeCareCheck === "true" && ( */}
                        <div className="col-md-3 multipleSearch-rounded">
                            <div className="input race">
                                <label className="hs-patient-label">Status</label>
                                <SuperSearchMultipleClient
                                    key={reloadSuperSearch}
                                    id="Status"
                                    name="Status"
                                    selectedOptionsDisplay='Status'
                                    initialSelectedValues={[]}
                                    searchParam={searchParam}
                                    setSearchParam={setSearchParam}
                                    options={isHomeCareCheck === "true" ? StatusOption1 : StatusOptionGrp}
                                    // StatusOption1?.filter(item => !['-1', -1].includes(item.value))}
                                    onSelect={handleMUltiSelectedData}
                                    sup_btn="sup_btn-Inp"
                                    sup_inp="superSearchVisitInp"
                                />
                            </div>
                        </div>
                        {/* )} */}
                        {/* <div className="col-lg-3">
                            <div className="input">
                                <label className="hs-patient-label">Insurance</label>
                                <select className="form-control fc-xs rounded" id='InsuranceID' name='InsuranceID' value={searchParam.InsuranceID}
                                    onChange={(e) => setSearchParam({ ...searchParam, SearchLetter: null, InsuranceID: e.target.value || null })}>
                                    {DropdownData.Insurance?.map((e, index) => (
                                        <option value={e.value} key={index}>
                                            {e.display}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div> */}
                        <div className="col-lg-3 d-flex align-items-end">
                            <button className={isEditAllowed ? 'btn btn-orange btn-xs no-width rounded me-3' : 'btn btn-orange btn-xs no-width rounded me-3 disabled'} onClick={SearchByParam}>Search</button>
                            <button className='btn btn-outline btn-xs no-width rounded' onClick={clearFilter}>Clear</button>
                        </div>
                    </div>
                    <div className="position-relative pe-4 hk-opt-bar d-flex gap-1 no-search-margin">

                        <SearchHeader
                            AddNew={AddNewPatient}
                            Filter={handleFilterOpen}
                            FilterClass={IsFilterApplied}
                            searchButton={searchButton}
                            Key={21}
                            tableName={isHomeCareCheck === "true" ? enumUtil.enumAPITableName.AgencyPatient : enumUtil.enumAPITableName.Patient}
                            Name={'PatientSearch'}
                            searchParam={{ ...searchParam, IsExcelExport: "1" }}
                            PerPage={PerPage}
                            PageNo={PageNo}
                            TotalPages={TotalPages}
                            isEmpty={patientData.length > 0}
                            componentColumns={AllColumnsName}
                            ColumnTableName={'Patient'}
                            enabled={SidebarActive === 2}
                        />
                        {isHomeCareCheck === "true" ? null :
                            <button className="btn-icon-transparent claim_submenu lh-10 position-relative" onClick={handleSubActiveMenu}><i class="icon-dots-menu"></i>
                                {<CustomUseRef onClose={closeDropdown} IsActivePtPayments={subMenuActive}>
                                    {subMenuActive === true ?
                                        <div className='claims-TabHeader__right__submenu right-7 top-100-5 active'>
                                            <div className="itemList">
                                                <div className={isBulkViewAllowed ? "itemList__item" : "itemList__item disabled"} onClick={hanldeOpenBulkEligibity}>Bulk Eligibility</div>
                                                <div className={isInstantViewAllowed ? "itemList__item" : "itemList__item disabled"} onClick={handleOpenInstantElibility}>Instant Eligibility</div>

                                            </div>
                                        </div>
                                        : null
                                    }
                                </CustomUseRef>}
                            </button>
                        }

                    </div>

                </div>
            </div>
            {isLoading ? <Loader /> : null}
            <div className="patient_filter position-relative">
                <Table
                    columns={columns}
                    rows={patientData}
                    height='465px'
                    rowClass={rowClass}
                    dynamicClass='fill-grid DataGrid-Table hk-exp-table  all_patient custom_checkboxes_gird'
                    rowHeight={25}
                    PerPage={PerPage}
                    PageNo={PageNo}
                    TotalPages={TotalPages}
                    handlePageClick={handlePageClick}
                    PreviousPage={PreviousPage}
                    handleFingByCreteria={handleFingByCreteria}
                    NextPage={NextPage}
                    Key={columns || checkBoxShow || patientData}
                    Name={'PatientSearch'}
                    selectedRows={selectedRows}
                    onSelectedRowsChange={onRowSelection}
                    isLoading={isLoading}
                    hideColClass='patient-hide'
                    // TableName={'Patient'}
                    colPopup='top-0'
                    handleSelectData={handleSelectData}
                    disableInput={true}
                    LoadData={() => LoadData(searchParam)}
                    ClearSearch={clearFilter}
                />
                <div className={`sidebar-filters ${filterShow && 'active'}`}>
                    <div className="sidebar-filters__heading">
                        <span>Filters</span>
                        <button className="btn btn-transparent" onClick={clearFilter}>
                            <i className="bi bi-x"></i>
                        </button>
                    </div>
                    <hr />
                    <div className="sidebar-filters__body h-100">
                        <div className="input filters-field multipleSearch-rounded">
                            <label>Provider</label>
                            <SuperSearchMultipleClient
                                key={reloadSuperSearch}
                                id="ProviderID"
                                name="ProviderID"
                                selectedOptionsDisplay='Provider'
                                initialSelectedValues={[]}
                                searchParam={searchParam}
                                setSearchParam={setSearchParam}
                                options={DropDowns.Provider?.filter(item => !['-1', -1].includes(item.value))}
                                onSelect={handleMUltiSelectedData}
                                sup_btn="sup_btn-Inp"
                                sup_inp="superSearchVisitInp"
                            />
                        </div>
                        {/* <hr /> */}
                        <div className="input filters-field multipleSearch-rounded">
                            <label>Location</label>
                            <SuperSearchMultipleClient
                                key={reloadSuperSearch}
                                id="LocationID"
                                name="LocationID"
                                selectedOptionsDisplay='Location'
                                initialSelectedValues={[]}
                                searchParam={searchParam}
                                setSearchParam={setSearchParam}
                                options={DropDowns.Location?.filter(item => !['-1', -1].includes(item.value))}
                                onSelect={handleMUltiSelectedData}
                                sup_btn="sup_btn-Inp"
                                sup_inp="superSearchVisitInp"
                            />
                        </div>
                        {isHomeCareCheck === "true" && (
                            <div className="input filters-field">
                                <div className='input simple_select position-relative'>
                                    <label>Coordinator</label>
                                    <SuperSearchList
                                        type="client"
                                        id='CoordinatorID'
                                        name='CoordinatorID'
                                        searchValue={selectCoordinator}
                                        data={DropDowns.CoOrdinator}
                                        onChange={(e) => handleChange(e)}
                                        getSelectedData={handleSelectedData}
                                        is={is}
                                        icon={'Simple'}
                                        sup_btn='sup_simple_btn'
                                        sup_inp='sup_simple_Inp'
                                        className="form-control rounded"
                                    />
                                </div>
                            </div>
                        )}
                        <div className="input filters-field">
                            <CalendaRangeInput searchParam={searchParam} setSearchParam={setSearchParam} options={['Entry Date']} />
                        </div>
                        {isHomeCareCheck === "true" ? null :
                            <div className="input filters-field multipleSearch-rounded">
                                <label htmlFor="">Eligibility Status</label>
                                <SuperSearchMultipleClient
                                    key={reloadSuperSearch}
                                    id="EligStatus"
                                    name="EligStatus"
                                    selectedOptionsDisplay='Status'
                                    initialSelectedValues={[]}
                                    searchParam={searchParam}
                                    setSearchParam={setSearchParam}
                                    options={StatusOption}
                                    sup_btn="sup_btn-Inp"
                                    sup_inp="superSearchVisitInp"
                                />
                            </div>
                        }
                    </div>
                    <div className="sidebar-filters__footer">
                        <button className="btn btn-orange" onClick={handleApply}>Apply</button>
                    </div>
                </div>
            </div>

            {/* Patient Search Modal */}
            <Modal show={false} onHide={false} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-lg master_list_modal">
                <Modal.Body>
                    <SearchHeader />
                    <ModalHeader HeaderName={patientHeader} DeletePopup={""} isClosed={() => { }} key={631} Name={'SwitchPractice'} />
                    <div className='container-fluid  br-clr'>
                        <div className="row">
                            <div className="col-12 mb-2 ">
                                <div className="input">
                                    <div className='input-group hk-input-search'>
                                        <input type="text" className='form-control fc-xs'
                                            placeholder='Search by name, DOB, account #, phone #'
                                        // onChange={e => setSearchParam(e.target.value)}
                                        // onKeyDown={SearchOnEnter} 
                                        />
                                        <span className="input-group-text" id="basic-addon2">
                                            <i className="bi bi-search"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="opened-block">
                                    <p className="heading">Recently Opened</p>
                                    <DataGrid
                                        columns={columnsAll}
                                        headerRowHeight={25}
                                        rowHeight={25}
                                        rows={rowsAll}
                                        className="all_audit fill-grid DataGrid-Table bg-light-blue sr-table popper-t-table"
                                    />
                                </div>
                            </div>
                            <div className="col-12 master_footer d-flex gap-3 mt-2 justify-content-end">
                                <button className="btn btn-orange btn-xs no-width rounded mb-0 master_list_add">Search</button>
                                <button className="btn btn-orange btn-xs no-width rounded mb-0 master_list_close">Cancel</button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

function mapStateToPropss(state) {
    return {
        OpenDynamicTab: state.Open_Patient_Tab ? state.Open_Patient_Tab : [],
        Settings: state.SettingsReducer
    };
}

const action = {
    TabActionPatient,
};

export default connect(mapStateToPropss, action)(PatientSearch);
